import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MasterclassService {
  baseUrl:string;

  private selectedMasterClassSubject = new BehaviorSubject<any>(null);
  selectedMasterClass$ = this.selectedMasterClassSubject.asObservable();


  private selectedDetailsSource = new BehaviorSubject<any>(null); 
  selectedDetails$ = this.selectedDetailsSource.asObservable();


  private selectedTab = new BehaviorSubject<any>(null);
  selectedTab$ = this.selectedTab.asObservable();

  private selectedIdSource = new BehaviorSubject<number | null>(null);
  selectedId$ = this.selectedIdSource.asObservable();


  private videoUrlSource = new BehaviorSubject<string | null>(null);
  videoUrl$ = this.videoUrlSource.asObservable();


  private videoTrailerSource = new BehaviorSubject<string | null>(null);
  videoTrailer$ = this.videoTrailerSource.asObservable();


  private videoSampleSource = new BehaviorSubject<string | null>(null);
  videoSample$ = this.videoSampleSource.asObservable();


  Url = `${environment.apiUrl}`;
  userToken = localStorage.getItem('master_token');
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'skip': 'true',
      'Authorization': this.userToken
    })
  };

  constructor(private http: HttpClient) {
    this.baseUrl = environment.masterApiUrl;
  }

  setTrailerVideo(url: string){
    this.videoTrailerSource.next(url);
  }

  setSampleVideo(url: string){
    this.videoSampleSource.next(url);
  }

  setVideoUrl(url: string): void {
    this.videoUrlSource.next(url); 
  }

  setSelectedId(id: number) {
    this.selectedIdSource.next(id);
  }
  
  setSelectedMasterClass(masterClass: any) {
    this.selectedMasterClassSubject.next(masterClass);
  }

  updateSelectedDetails(details: any) {
    this.selectedDetailsSource.next(details);
  }

  selectedTabFlag(seletedTab: any){
    this.selectedTab.next(seletedTab);
  }

  getToken(){
    return this.http.get(this.Url + 'updateToken', {responseType: 'text'});
  }

  getMasterClasses(lms_subject_id:number, lms_topic_id:number):Observable<any>{
    let params = new HttpParams();
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'skip': 'true',
        'Authorization': localStorage.getItem('master_token')
      })
    };
    if (lms_subject_id) {
      params = params.set('lms_subject_id', lms_subject_id.toString());
    }
    if (lms_topic_id) {
      params = params.set('lms_topic_id', lms_topic_id);
    }
    return this.http.get(`${this.baseUrl}masterclass`, { params, ...httpOptions }).pipe(catchError(this.handleError));
  }

   /* Handling errors */
   private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }



  getSelectedDetails(id: number): Observable<any> {
    const url = `${this.baseUrl}masterclass/details?id=${id}`;
    return this.http.get(url, this.httpOptions);
  }
  

  newlyAdded(value){
    const url = `${this.baseUrl}masterclass?masterclassassignment__enable_newly_added=${value}`;
    return this.http.get(url, this.httpOptions);
  }


  personal(){
    const url = `${this.baseUrl}user/recently_viewed`;
    return this.http.get(url, this.httpOptions);
  }


  popular(value){
    const url = `${this.baseUrl}masterclass?masterclassassignment__enable_highlight=${value}`;
    return this.http.get(url, this.httpOptions);
  }


  author(id){
    const url = `${this.baseUrl}masterclass?host_instructor_id=${id}`;
    return this.http.get(url, this.httpOptions);
  }

}
